import { useLayoutEffect, useRef } from "react";
import { isIndia, EDITION } from "@/lib/edition";

// On the India edition, swap the "AlumniPulse" brand to the India brand within
// long-form content pages. Scoped per-page so intended global-site cross-links
// (which live in the shared layout/home) are never touched.
export function BrandSwap({ children }) {
  const ref = useRef(null);
  useLayoutEffect(() => {
    if (!isIndia || !ref.current) return;
    const swap = (s) => s.replace(/AlumniPulse\.net/g, EDITION.domain).replace(/AlumniPulse/g, EDITION.brand);
    const walk = (node) => {
      node.childNodes.forEach((n) => {
        if (n.nodeType === 3) {
          if (n.nodeValue && n.nodeValue.indexOf("AlumniPulse") !== -1) n.nodeValue = swap(n.nodeValue);
        } else if (n.nodeType === 1 && !["SCRIPT", "STYLE", "INPUT", "TEXTAREA"].includes(n.tagName)) {
          walk(n);
        }
      });
    };
    walk(ref.current);
  });
  return <div ref={ref}>{children}</div>;
}

export default BrandSwap;
